import { useAtom } from "jotai";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import { GoArrowRight } from "react-icons/go";
import { useTranslation } from "react-i18next";
import { itemsAtom, tripodsAtom } from "src/atoms/constantsCheckout";
import TripodsStepCard from "./TripodsStepCard";

interface Props {
    step: number;
    setStep: Dispatch<SetStateAction<number>>;
    packages: any[];
}

const TripodsStep = ({ step, setStep, packages }: Props) => {
    const [items, setItems] = useAtom(itemsAtom);
    const [tripods, setTripods] = useAtom(tripodsAtom);
    const { t } = useTranslation();
    const continueButtonClass =
        "border bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 flex items-center space-x-4 text-white px-6 py-3 text-sm font-medium rounded-2xl shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all duration-200";
    useEffect(() => {
        const smallTripodPackage = packages.find((pkg) => pkg.id === "5");
        const bigTripodPackage = packages.find((pkg) => pkg.id === "6");

        setTripods([
            {
                id: 0,
                title: "Tripod Carbon 6,1m",
                price: smallTripodPackage ? parseFloat(smallTripodPackage.price) : 10,
                quantity: 0,
                price_id: "price_1TMohm7plh7U2nikejcYwnkL"
            },
            {
                id: 1,
                title: "Tripod Carbon 7,1m",
                price: bigTripodPackage ? parseFloat(bigTripodPackage.price) : 10,
                quantity: 0,
                price_id: "price_1TMoiL7plh7U2nikaNi93HnK"
            },
        ]);
    }, [packages]);

    const updateQuantity = (id: number, delta: number) => {
        setTripods((prevItems: any) => {
            const updatedItems = prevItems.map((item: any) =>
                item.id === id
                    ? { ...item, quantity: Math.max((item.quantity || 0) + delta, 0) }
                    : item
            );
            return updatedItems;
        });
    };

    return (
        <div className="h-full wiz-custom-scroll-bar p-14 lg:w-3/4">
            <div className="max-w-6xl mx-auto px-6 py-8">
                {" "}
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-3">
                        {t("tripodsStep.title")}
                    </h1>
                    <p className="text-lg text-gray-600 leading-relaxed">
                        {t("tripodsStep.description")}
                    </p>
                </div>
                <div className="flex flex-col justify-between h-[95%]">
                    <div className="mt-4 mb-auto">
                        <div className="grid lg:grid-cols-2 gap-8 mb-12 mt-4">
                            {tripods.map((i: any) => (
                                <TripodsStepCard
                                    item={i}
                                    key={i.id}
                                    updateQuantity={updateQuantity}
                                />
                            ))}
                        </div>
                    </div>
                    <div className="flex items-center space-x-4 ">
                        <button
                            onClick={() => setStep(step - 1)}
                            className="border border-[#333] px-6 py-3 text-sm font-medium rounded-full"
                        >
                            <p> {t("tripodsStep.buttons.goBack")}</p>
                        </button>
                        <button
                            onClick={() => {
                                setStep(step + 1);
                                setItems((prev: any) => ({
                                    ...prev,
                                    tripods:
                                        tripods?.length > 0 &&
                                        tripods
                                            ?.filter((item: any) => item.quantity > 0)
                                            .map((item: any) => ({
                                                type: item.title,
                                                quantity: item.quantity,
                                                price: item.price,
                                                totalPrice: item.quantity * item.price,
                                                price_id: item.price_id
                                            })),
                                        }));
                            }}
                            className={continueButtonClass}
                        >
                            <p>{t("tripodsStep.buttons.continue")}</p>
                            <GoArrowRight className="h-5 w-5" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TripodsStep;
